export function getState(storageKey) {
    try {
        const s = sessionStorage.getItem(storageKey);
        return s ? JSON.parse(s) : {};
    } catch (error) {
        console.error(error);
        return {};
    }
}

export function saveState(storageKey, state) {
    try {
        sessionStorage.setItem(storageKey, JSON.stringify(state));
    } catch (error) {
        console.error(error);
    }
}

const baseSensitivityCollator = new Intl.Collator(undefined, { sensitivity: 'base' });

export function compareValues(a, b, dir) {
    const numA = Number(a);
    const numB = Number(b);
    if (!Number.isNaN(numA) && !Number.isNaN(numB)) {
        const cmp = numA < numB ? -1 : numA > numB ? 1 : 0;
        return dir === 'asc' ? cmp : -cmp;
    }
    const sa = String(a ?? '');
    const sb = String(b ?? '');
    const cmp = baseSensitivityCollator.compare(sa, sb);
    return dir === 'asc' ? cmp : -cmp;
}

export function findFooter(grid) {
    const region = grid.parentElement;
    if (!region || !region.classList.contains('data-grid-scroll-region')) {
        return null;
    }
    const next = region.nextElementSibling;
    return next && next.classList.contains('data-grid-footer') ? next : null;
}
